<template>
  <transition name="popup">
    <div v-if="visible" class="new-user-popup-overlay">
      <div class="new-user-popup">
        <div class="popup-content" dir="rtl">
          <h3 class="mb-0">🌱 خوش اومدی به جالیزان!</h3>
          <div class="body">
            <p class="mb-1">ما اینجا هستیم تا در مدیریت مزرعه ات بهت کمک کنیم.</p>
            <p class="mb-3">از امروز تنها نیستی، جالیزان دستیارته!</p>
            <p class="mb-4">📍 برای شروع، بیا تو مزرعت یه چرخی بزنیم و وضعیتش رو بررسی کنیم...</p>
            <button @click="handleClose" class="close-btn">بستن</button>
          </div>
        </div>
      </div>
    </div>
  </transition>
</template>

<script>
export default {
  name: 'WelcomePopup',
  props: {
    visible: {
      type: Boolean,
      required: true
    }
  },
  emits: ['close'],
  methods: {
    handleClose() {
      this.$emit('close');
    }
  }
};
</script>

<style scoped>
.new-user-popup-overlay {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  background-color: rgba(0, 0, 0, 0.7);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 9999;
}

.new-user-popup {
  background-color: white;
  border-radius: 24px;
  width: 90%;
  max-width: 500px;
  box-shadow: 0 4px 20px rgba(0, 0, 0, 0.15);
}

.popup-content {
  text-align: center;

  .body {
    padding: 30px 16px;
  }
}

h3 {
  color: white;
  font-weight: bold;
  padding: 30px 16px;
  background: #3ea58a;
  border-radius: 24px 24px 0 0;
  font-size: 24px;
}

p {
  color: #283745;
  font-size: 16px;
}

.close-btn {
  background-color: #3ea58a;
  color: white;
  border: none;
  padding: 0.5rem 1.5rem;
  border-radius: 50px;
  cursor: pointer;
  font-size: 13px;
  transition: background-color 0.3s;
}

.close-btn:hover {
  background-color: #2f8d74;
}

/* Animation styles */
.popup-enter-active,
.popup-leave-active {
  transition: opacity 0.3s ease;
}

.popup-enter-from,
.popup-leave-to {
  opacity: 0;
}

.popup-enter-active .new-user-popup,
.popup-leave-active .new-user-popup {
  transition: transform 0.3s ease;
}

.popup-enter-from .new-user-popup,
.popup-leave-to .new-user-popup {
  transform: scale(0.9);
}

</style>